import React from 'react';
// Custom Imports
import ReactTable from '../../../utils/react-table';
import { IconLocationDot, IconTruck, IconXmark, IconQuestion } from '../../ui-kit/icons';
import { StatusButton, SkillSelector } from '../shared/Fields';
import { ButtonGroup } from '../../ui-kit';
import { attendanceTimesColumn, userColumn, groupColumn, rankColumn } from '../shared/shared-columns';
import AvailabilityIcon from '../../general/AvailabilityIcon';

const didAttend = response => response.reported_status === 'dispatched';

const AvailabilityStatusIndicator = ({ response }) => {
  const { available_at_incident_creation, active_duty_function_ids } = response;
  const onDuty = active_duty_function_ids.length > 0;
  return <AvailabilityIcon available={available_at_incident_creation} standbyDuty={onDuty} />;
};

const columns = () => [
  {
    accessor: d => d.attendance.available_at_incident_creation,
    id: 'availability',
    maxWidth: 30,
    filterable: false,
    Cell: row => {
      const data = row.original;
      if (data.attendance.available_at_incident_creation === undefined) return null;
      return <AvailabilityStatusIndicator response={data.attendance} />;
    }
  },
  userColumn(150),
  groupColumn(150),
  {
    Header: I18n.t('activerecord.attributes.incidents/incident_response.reported_status'),
    accessor: d => d.attendance.reported_status,
    id: 'status',
    minWidth: 50,
    filterable: false,
    Cell: row => {
      const data = row.original;
      const translate = key => I18n.t(`classy_enum.incidents/incident_response_reported_status.${key}`);
      const buttons = [
        { style: 'success', status: 'dispatched', icon: <IconTruck /> },
        { style: 'info', status: 'shown_up', icon: <IconLocationDot /> },
        { style: 'danger', status: 'no_show', icon: <IconXmark /> },
        { style: 'warning', status: 'unknown', icon: <IconQuestion /> }
      ];
      return (
        <ButtonGroup size="sm" className="attendance-status">
          {buttons.map(b => (
            <StatusButton {...b} key={b.status} data={data} title={translate(b.status)} />
          ))}
        </ButtonGroup>
      );
    }
  },
  rankColumn(didAttend),
  {
    Header: I18n.t('activerecord.attributes.incidents/incident_response.assigned_skills'),
    id: 'assignedSkills',
    filterable: false,
    Cell: row => {
      const { attendance, eligibleSkills, saveAttendance } = row.original;
      return (
        didAttend(attendance) && (
          <SkillSelector attendance={attendance} eligibleSkills={eligibleSkills} saveAttendance={saveAttendance} />
        )
      );
    }
  },
  attendanceTimesColumn(didAttend)
];

const ResponsesTable = ({
  attendances,
  ranks,
  currentGroupId,
  currentReportStartTime,
  currentReportEndTime,
  saveAttendance,
  overlappingAttendancesByUserId
}) => {
  const data = attendances
    .filter(a => a.group && a.user)
    .map(attendance => ({
      attendance,
      user: attendance.user,
      group: attendance.group,
      eligibleSkills: attendance.eligibleSkills,
      eligibleRanks: ranks,
      currentGroupId,
      currentReportStartTime,
      currentReportEndTime,
      saveAttendance,
      overlappingAttendances: (overlappingAttendancesByUserId[attendance.user.id] || []).filter(
        a => attendance.reported_status === 'dispatched' && a.id !== attendance.id
      )
    }));

  return (
    <>
      <h2>{I18n.t('activerecord.models.incidents/incident_response')}</h2>
      <ReactTable
        filterable
        className="attendance-table"
        showPagination={true}
        defaultSorted={[{ id: 'availability', desc: true }, { id: 'status' }, { id: 'groupName' }, { id: 'userName' }]}
        defaultFiltered={[{ id: 'groupName', value: true }]}
        data={data}
        columns={columns()}
      />
    </>
  );
};

export default ResponsesTable;
